import { LoadingContext } from "components/LocalisedLoadingProvider";
import React from "react";

function useLoading() {
  return React.useContext(LoadingContext);
}
export default useLoading;
